import { CheckCircleIcon, SpinnerIcon } from '@phosphor-icons/react';

export default function Step({
  title,
  state,
  children,
  refEl,
  isLast,
  onTitleClick,
  icon
}: {
  title: string;
  state: 'loading' | 'incomplete' | 'complete';
  children?: React.ReactNode;
  refEl?: React.RefObject<HTMLDivElement>;
  isLast?: boolean;
  onTitleClick?: () => void;
  icon?: React.ReactNode;
}) {
  const computedIcon =
    state === 'loading' ? (
      <SpinnerIcon size={16} className="text-content-subtlest animate-spin" />
    ) : state === 'complete' ? (
      <CheckCircleIcon size={16} className="text-green-600" />
    ) : (
      <span className="w-4 h-4 rounded-full border border-border-default inline-block" />
    );
  const displayedIcon = icon ?? computedIcon;

  return (
    <div ref={refEl} className="flex gap-2">
      <div className="flex flex-col items-center">
        <div className="mt-1 w-4 h-4 flex items-center justify-center">{displayedIcon}</div>
        {!isLast && <div className="flex-1 w-px bg-border-default mt-2" />}
      </div>
      <div className="flex-1 pb-4">
        <button
          type="button"
          onClick={onTitleClick}
          className="text-left text-sm font-medium text-content-default hover:underline"
        >
          {title}
        </button>
        {state === 'loading' && children && <div>{children}</div>}
      </div>
    </div>
  );
}
